import { render, staticRenderFns } from "./TableDuties.vue?vue&type=template&id=1087b109"
import script from "./TableDuties.vue?vue&type=script&lang=js"
export * from "./TableDuties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports